import React, { useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import axios from "axios";
import { BackButton, CancelButton, CreateButton, SubmitButton } from "../../../../Components/Utils/Buttons";

import { NuDate, NuInput, NuTextArea } from "../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { useToast } from "../../../../Components/Others/ToastServices";
import { useFormik } from "formik";
import axiosInstance from "../../../../Services/axiosCommon";
import * as yup from 'yup';
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { Modal, notification } from "antd";
import DeleteIcon from "../../../../Components/Icons/Delete";

const IndexHoliday = () => {
  const calendarRef = useRef(null);
  const [holidayList, setHolidayList] = useState([]);
  const [selectedHoliday, setSelectedHoliday] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 21 }, (_, i) => currentYear - 10 + i);
  };

  const getData = () => {
    axiosInstance
      .get(`/holidays/month/${currentMonth}/year/${currentYear}`)
      .then((res) => {
        if (res.data?.data) setHolidayList(res.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching holiday data:", error);
      });
  };

  useEffect(() => {
    getData(currentMonth, currentYear);
  }, [currentMonth, currentYear]);

  useEffect(() => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(
        `${currentYear}-${String(currentMonth).padStart(2, "0")}-01`
      );
    }
  }, [currentMonth, currentYear]);

  const events = holidayList?.map((holiday) => ({
    id: holiday.id,
    title: holiday.description,
    start: holiday.date,
    extendedProps: { ...holiday },
  }));

  const handleEventClick = (info) => {
    setSelectedHoliday(info.event.extendedProps);
  };

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    if (name === "month") setCurrentMonth(parseInt(value, 10));
    else if (name === "year") setCurrentYear(parseInt(value, 10));
  };
  function prevMonth() {
    if (currentMonth == 1) {
      setCurrentMonth(12);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  }

  function nextMonth() {
    if (currentMonth == 12) {
      setCurrentMonth(1);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  }

  const toast = useToast();
      const [data, setData] = useState([])
      const [open, setOpen] = useState(false)
      const [creatNew,setCreateNew]= useState({
        start_date:"",
        end_date:"",
        type:"",
        description:"",
      date:"",
  
      })
  const formik = useFormik({
    initialValues:creatNew,
    enableReinitialize:true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      type: yup.string().required('Type is requred!'),
      start_date: yup.string().required('Start date is requred!')
    }),
    onSubmit: async (value, { resetForm }) => {
      axiosInstance
      .post(`/holidays/add_holidays`,value).then(res=>{
        if(res?.data?.status==true){
          // ActiveUser(value?.userId)
          resetForm()
          getData()
          toast.open({
            type:"success",
            message:"Success",
            description: res.data?.msg || "Created Successfully."
          })
          setOpen(false)
        }else{
          toast.open({
            type:"error",
            message:"Error",
            description: res.data.error || res.data?.msg || res.data?.message  || "Network error."
          })
        }
      }).catch(err=>{
        console.error(err);
        toast.open({
          type:"error",
          message:"Error",
          description: err.response.data.error || err.response.data.message || err.response.data.msg || "Network error."
        })
      })
 }
  })
  function OnClose(){
    formik.resetForm() 
    setOpen(false)
  }
  const [api, contextHolder] = notification.useNotification();

  const handleDelete = (id,month, year) => {
    Modal.confirm({
      title: "Are you sure you want to delete ?",
      width:"25%",
      centered:true,
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        axiosInstance
          .delete(`/holidays/delete_holiday/${id}`)
          .then((res) => {
            if (res.status === 200 || res.data.status === true) {
              api.success({
                message: "Deleted",
                description: res?.data?.msg || "Deleted successfully",
                placement: "bottomRight",
              });
              getData();
            }
          })
          .catch((err) => console.error(err));
      },
    });
  };
 

  return (
    <div className='w-full h-full px-4 py-2'>
    <div className='w-full flex justify-between items-center'>
    <Breadcrumb
      items={[
        {
          name: "Settings",
        },
        {
          name: "Holidays"
        }
      ]}
    />
    <div className=" flex gap-2 items-center">
      <CreateButton handleClick={()=>setOpen(true)} label="Create" />
      <BackButton/>

    </div>
    
    </div>
    <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto rounded-md overflow-y-hidden px-2">
      <div className=" relative w-full h-[calc(100vh-176px)] overflow-y-auto mt-4">

<div className="flex  justify-between gap-2"> 
<h1 className="text-sm font-semibold ">Calendar</h1>
<div className="flex gap-2">
        <button onClick={prevMonth} className=" font-bold text-xl">
        <svg
            width="7"
            height="12"
            viewBox="0 0 10 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.39019 1.21179C9.61683 1.43849 9.74414 1.74592 9.74414 2.06648C9.74414 2.38703 9.61683 2.69446 9.39019 2.92116L3.40621 8.90514L9.39019 14.8891C9.6104 15.1171 9.73225 15.4225 9.7295 15.7395C9.72674 16.0564 9.59961 16.3596 9.37547 16.5838C9.15133 16.8079 8.84813 16.935 8.53116 16.9378C8.2142 16.9406 7.90883 16.8187 7.68083 16.5985L0.842158 9.75983C0.615527 9.53313 0.488212 9.2257 0.488212 8.90514C0.488212 8.58459 0.615527 8.27716 0.842158 8.05046L7.68083 1.21179C7.90753 0.985163 8.21496 0.857849 8.53551 0.857849C8.85607 0.857849 9.1635 0.985163 9.39019 1.21179Z"
              fill="#000000"
            />
          </svg>
        </button>
        <div>
          <select
            name="month"
            value={currentMonth}
            onChange={handleDropdownChange}
            className="border-none rounded p-1 outline-none text-[11px] 2xl:text-xs"
          >
            {[
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ].map((month, index) => (
              <option key={index} value={index + 1} className=" text-xs ">
                {month}
              </option>
            ))}
          </select>
        </div>
        <div>
          <select
            name="year"
            value={currentYear}
            onChange={handleDropdownChange}
            className="border-none outline-none rounded p-1 text-xs "
          >
            {generateYears().map((year) => (
              <option key={year} value={year} className=" text-[11px] 2xl:text-xs">
                {year}
              </option>
            ))}
          </select>
        </div>
        <button onClick={nextMonth} className=" font-bold text-2xl">
        <svg
            width="7"
            height="12"
            viewBox="0 0 10 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.877383 16.5839C0.650752 16.3572 0.523438 16.0497 0.523438 15.7292C0.523438 15.4086 0.650752 15.1012 0.877384 14.8745L6.86137 8.89051L0.877385 2.90652C0.657177 2.67853 0.535327 2.37316 0.538082 2.05619C0.540836 1.73923 0.667974 1.43602 0.892111 1.21188C1.11625 0.987747 1.41945 0.860611 1.73642 0.857857C2.05338 0.855103 2.35875 0.976952 2.58675 1.19716L9.42542 8.03583C9.65205 8.26253 9.77937 8.56996 9.77937 8.89051C9.77937 9.21106 9.65205 9.51849 9.42542 9.74519L2.58675 16.5839C2.36005 16.8105 2.05262 16.9378 1.73207 16.9378C1.41151 16.9378 1.10408 16.8105 0.877383 16.5839Z"
              fill="#000000"
            />
          </svg>
          </button>
          </div>
        </div>
        <div className=" w-full h-[calc(100%-3rem)] overflow-hidden mx-auto">

     
        <FullCalendar
  ref={calendarRef}
  plugins={[dayGridPlugin, interactionPlugin]}
  initialView="dayGridMonth"
  selectable
  editable
  events={events} // <-- pass your events here
  headerToolbar={{
    start: "",
    center: "",
    end: "",
  }}
  height={"100%"}
  eventClick={(e) => setSelectedHoliday(e.event.extendedProps)}
  resourceAreaWidth="100%"
  resourceAreaHeight="20%"
  fixedWeekCount={false}
  eventDidMount={(info) => {
    // Set the description as the title attribute for tooltip
    info.el.setAttribute("title", info.event.title);
  }}
/>

</div>
     
    </div>
    </div>
      {open && (
      <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
      <div className="animate-scale-in relative w-[45%] min-h-[50%] max-h-[96%] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
        <button
          className="absolute top-2 right-2 text-white bg-red-600"
          onClick={() => setOpen(false)}
        >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <p className=" text-sm font-semibold">Create Holidays </p>
          <form onSubmit={formik.handleSubmit}>
          <div className=" w-full h-full py-4 px-3 flex justify-start content-start flex-wrap ">
           
        
                 <FormikSelectTwo
                  label="Type"
                  Options={[
                    {value: 1, label:"Single"},
                    {value: 2, label:"Multiple"},
                  ]}
                  formik={formik}
                  placeholder="Choose"
                  name="type"
                  width="w-full "
            
    
              />
                     
                          
    {formik.values.type === 2 ? (
        <>
         <NuDate
                            label="Start Date"
                            placeholder="DD/MM/YYYY"
                            formik={formik}
                            name="start_date"
                            width="w-full"
                           
    
                          /> <NuDate
                          label="End Date"
                          placeholder="DD/MM/YYYY"
                          formik={formik}
                          name="end_date"
                          width="w-full"
                        />
                        </>
     
    ): <NuDate
    label="Date"
    placeholder="DD/MM/YYYY"
    formik={formik}
    name="date"
    width="w-full"
   

  />}
      <NuTextArea
             type="text"
             label="Description"
             placeholder="Description"
             formik={formik}
             name="description"
             width="w-full "
             new_width='w-full'
            
                                        />
          </div>
          <div className="w-full hidden md:block mx-auto my-4 mt-8 ">
                  <div className="md:flex justify-end gap-4">
                    <CancelButton
                      handleClick={OnClose}
                    />
                    <SubmitButton />
                  </div>
                </div>
          </form>
        </div>
      </div>
    )}
    {selectedHoliday && (
  <Modal
    open={true}
    onCancel={() => setSelectedHoliday(null)}
    footer={null}
    title="Holiday Details"
  >
    <div className="flex text-sm">
    <p className="w-1/4 text-sm font-semibold">Description</p><p>: {selectedHoliday.description}</p></div>
    <div className="flex text-sm">  <p className="w-1/4 text-sm font-semibold">Date</p><p>: {new Date(selectedHoliday.date).toLocaleDateString('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
})}</p></div>

    <button onClick={() => handleDelete(selectedHoliday.id)}><DeleteIcon/></button>
  </Modal>
)}

    </div>
  );
};

export default IndexHoliday;
